import { Button } from '@workspace/shadcn';

import { useModals } from '../components/modals.tsx';
import { Section } from '../components/section.tsx';
import { RetroGrid } from '../components/effects/retro-grid.tsx';

export function ContactUs() {
  const { open } = useModals();

  return (
    <Section className="h-[400px] overflow-hidden pb-0!">
      <h2 className="text-center text-4xl font-bold tracking-tighter">
        Get in Touch
      </h2>
      <p className="text-muted-foreground mx-auto my-4 max-w-[640px] text-center">
        Have questions about our courses or need more information? We are here
        to help. Reach out to our team for personalized assistance.
      </p>
      <div className="mt-6 flex items-center justify-center">
        <Button
          className="h-12 px-8 text-base text-white dark:text-black"
          onClick={() => open('contact')}
        >
          Contact Us
        </Button>
      </div>
      <div className="relative -top-20 -z-10 h-[360px] overflow-hidden">
        <RetroGrid className="-top-40" />
      </div>
    </Section>
  );
}
